export default __webpack_public_path__ + "static/media/home-hero.0d1948e8.jpg";